export default "__VITE_ASSET__BOs8ocvG__"